const state = {
  container: null,
  component: null,
  properties: null,
};

const actions = {
  show({ commit }, { component, properties }) {
    commit('setModal', { component, properties });
  },

  dismiss({ commit }) {
    commit('removeModal');
  },
};

const mutations = {
  setModal(state, { component, properties }) {
    state.component = component;
    state.properties = properties;
  },

  removeModal(state) {
    state.component = null;
    state.properties = null;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
